<template>
  <div class="layout-faq-page">
    <div class="container">
      <div class="header">
        <slot name="breadcrumbs"></slot>
        <div class="title s-65 font-palantino">
          <slot name="title"></slot>
        </div>
      </div>
      <!--  -->
      <div class="content">
        <slot name="menu" :askQuestion="askQuestion"></slot>
        <slot name="detailcontent"></slot>
      </div>
      <div class="paginator">
        <slot name="paginator"></slot>
      </div>
    </div>

    <layout-popup v-model="askQuestionModel" :sended="sended">
      <div class="s-30 w-500">ЗАДАЙТЕ НАМ ВОПРОС</div>
      <div class="s-16 opacity-80"></div>
      <template slot="form">
        <input required placeholder="Как Вас зовут" v-model="faq_name" type="text" class="ui-input" />
        <input required placeholder="Ваш город" type="text" v-model="faq_city" class="ui-input" />
        <input required placeholder="your_email@example.com" type="email" v-model="rev_email" class="ui-input" />


        <select v-model="faq_category" class="ui-input">
          <option value="">Не выбрано</option>
          <option :value="option" v-for="(option, index) in category" :key="index">{{ option.NAME }}</option>
        </select>

        <textarea placeholder="Задать нам вопрос" v-model="faq_message" rows="5" class="ui-input"></textarea>

        <ui-button @click="sendAskQuestion()" style="margin-top: 1em;">Отправить</ui-button>
      </template>
      <div slot="suffix" class="s-12">
        Оставляя Ваш email, вы соглашаетесь с политикой обработки персональных данных
      </div>
    </layout-popup>
  </div>
</template>

<script>
export default {
  props:{
    category: []
  },
  data(){
    return {
      askQuestionModel: false,
      sended: false,
      faq_name: "",
      rev_email: "",
      faq_city: "",
      faq_category: "",
      faq_message: "",
    }
  },
  methods:{
    askQuestion(){
      this.askQuestionModel=true;
    },
    sendAskQuestion() {
      if( this.faq_name==="" || this.rev_email==="" || this.faq_message==="" ){
        //this.$notify({group: 'error-form', title: 'error', text: this.$store.state.langs.NOTIFICATION_ERROR_FIELD, type: 'error'});
        return false;
      }
      this.$axios({
        url: '/ajax/',
        method: 'post',
        params: {
          askquestion: "Y",
          faq_name: this.faq_name,
          faq_city: this.faq_city,
          rev_email: this.rev_email,
          faq_category: this.faq_category.ID,
          faq_message: this.faq_message,
          url: location.href
        }
      }).then(response => {
        if (response.status == 200 && response.data.success) {
          //console.log( "response", response );


            if (typeof (ym) === "function") {
              let yaCounterId = this.$store.state.langs.YACOUNTER;
              ym(yaCounterId, 'reachGoal', 'askQuestion_sentForm');
            }
          this.sended = true;
        }else{
          console.log('Error feedback success: false')
        }
      }).catch(e => {
        console.log('Error: ' + e)
      })
      //this.loading = false;
    },
  },
  components: {
    'icon-eye': () => import('@/components/icon/icon-eye.vue'),
    'ui-button': () => import('@/components/ui/ui-button.vue'),
    'layout-popup': () => import('@/components/layout/layout-popup'),
  }
}
</script>

<style lang="scss" scoped>
.layout-faq-page {
  padding: 3em 0;
}
.header {
  text-align: center;
}
.title {
  margin-top: 20px;
  * {
    font: inherit;
  }
}
.about {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
  gap: 30px;
}
.image {
  position: relative;
  height: 500px;
  overflow: hidden;
  border-radius: 7px;
  margin: 50px 0;
  * {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.content {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: flex-start;
  gap: 80px;
  padding: 10px;

  .detail-content {
    grid-column: 1 / 3;
    grid-row: 1/2;
  }
  .detail-menu {
    grid-column: 3 / 4;
    grid-row: 1/2;
    position: sticky;
    top: 150px;
    background: var(--light);
    border-radius: 10px;
    padding: 20px;
    ul {
      margin-top: 10px;

      li {
        list-style: none;
        margin-bottom: 5px;

        a {
          text-decoration: underline;
          cursor: pointer;
          display: block;
          text-transform: uppercase;
        }
      }
    }
    .detail-menu-head {
      font-weight: 600;
      margin-bottom: 10px;
    }
  }
}
.detail-content {
  & > * {
    font-size: 18px;
    line-height: 160%;
  }
}
.more {
  text-align: center;
  margin-top: 30px;
  padding-top: 30px;
  border-top: solid 1px var(--light);
  &-title {
    margin-bottom: 40px;
  }
}
@media screen and (max-width: 767px) {
  .title {
    font-size: 36px;
  }
  .header {
    padding: 0 15px;
  }
  .image {
    margin: 20px 0;
    height: 200px;
  }
  .content {
    display: block;
    padding: 0 15px;
    .detail-menu {
      margin-bottom: 15px;
      position: relative;
      top: unset;
    }
  }
}
</style>
<style lang="scss">
.layout-faq-page {
  .header.row-between{
    svg {
      min-width: 18px;
    }
  }
  .content-tab__top{
    display: flex;
  }
  .content-tab__content{
    display: flex;
  }
  .askQuestion{
    text-align: right;
    cursor: pointer;
  }
}
</style>
